import { ua } from './modules/ua'
import { klass, scrollSmooth, inViewSet, galleryImages } from './modules/common'
import { mountSlider } from './modules/mountSlider'

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.init()
  }

  init() {
    // 全ページ共通適用
    this.body.classList.add(`is-${ua.browser()}`)
    this.body.classList.add(`is-${ua.os()}`)
    this.pageCommonSetting()

    window.addEventListener('resize', () => {
      //
    })
    window.addEventListener('scroll', () => {
      //
    })
  }

  pageCommonSetting() {
    inViewSet()

    // ナビゲーション開閉
    document.querySelector('.navigation-trigger').addEventListener('click', () => {
      document.querySelector('body').classList.toggle(klass.nav)
    })

    if (!this.body.classList.contains('page-index')) {
      setTimeout(() => {
        this.body.classList.add('is-loaded2')
      }, 1000)
    }

    // スムーススクロール
    const smoothScrollTarget = Array.from(document.querySelectorAll('.js-smooth-scroll'))
    if (smoothScrollTarget.length > 0) {
      smoothScrollTarget.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          const targetId = e.target.hash
          document.querySelector('body').classList.remove('view-nav')

          if (!document.querySelector(targetId)) {
            return false
          }
          scrollSmooth(targetId)
        })
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.vMode = new App()
})

window.addEventListener('load', () => {
  mountSlider()
  galleryImages()
})

window.initMap = () => {
  const myLatlng = new google.maps.LatLng(35.64687280510573, 140.14826586592702)
  const styleOptions = [
    {
      featureType: 'administrative.land_parcel',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.business',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
  ]
  const myOptions = {
    zoom: 18,
    center: myLatlng,
    disableDefaultUI: true,
    styles: styleOptions,
  }
  const map = new google.maps.Map(document.getElementById('map-canvas-access'), myOptions)
  const marker = new google.maps.Marker({
    position: myLatlng,
    map: map,
    icon: {
      url: '/wp-content/themes/v-mode_v1/assets/img/common/map-pin.png',
      size: new google.maps.Size(42, 36),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 36),
      scaledSize: new google.maps.Size(42, 36),
    },
  })
}
